module.exports = __webpack_public_path__ + "img/13.e53ff7ab.jpg";